import axios from 'axios'
import qs from 'qs'
import { ResetMessage } from "@/utils/utils";


axios.defaults.baseURL = process.env.VUE_APP_API_PATH //接口基础路径

axios.defaults.timeout = 30000 //超时时间
axios.defaults.withCredentials = false //请求是否带上cookie
axios.interceptors.response.use(
    async function (response) {
        //响应拦截
        return response
    },
    function (error) {
        return Promise.reject(error.response ? error.response : error)
    }
)
axios.interceptors.request.use(function (request) {
    if (request.url.indexOf('learnTimes/add') > -1) {
        request.timeout = 2000
    }
    return request
})
axios.defaults.headers = {
    //默认headers
    'Content-Type': 'application/json-patch+json',
    'X-SS-API-KEY': '20f7f775-bbd6-445e-8c2f-cb3d9b77920b'
}

export const CallBack = {} //回调
async function ajax({ url, type = 'get', param = null }) {
    try {
        let get = async function () {
            let res
            if (!param) {
                res = await axios[type](url)
            } else {
                switch (type) {
                    case 'get':
                        res = await axios[type](url, {
                            params: param,
                            paramsSerializer: (params) => {
                                //  参数是对象序列化，否则就是字符串
                                if (params instanceof Object) {
                                    return qs.stringify(params, { indices: false })
                                } else {
                                    return params
                                }
                            },
                        })
                        break
                    case 'post':
                        res = await axios[type](url, param, {
                            indices: false,
                        })
                        break
                    case 'put':
                        res = await axios[type](url, param, {
                            indices: false,
                        })
                        break
                    case 'delete':
                        res = await axios[type](url, {
                            params: param,
                            paramsSerializer: (params) => {
                                return qs.stringify(params, { indices: false })
                            },
                        })
                        break
                }
            }
            return res
        }
        let res = await get()
        return res.data
    } catch (res) {
        if (res.status) {
            switch (res.status) {
                case 401:
                    if (CallBack.unauthorized) {
                        ResetMessage.error({
                            content: res.data.error ?
                                res.data.error.details || res.data.error.message : res.statusText,
                        })

                        CallBack.unauthorized(res)


                    }
                    throw new Error(res)
                default:
                    if (errMsgWhite(url)) {
                        ResetMessage.error({
                            content: res.data.error ?
                                res.data.error.details || res.data.error.message : res.statusText,
                        })
                    }
                    return Promise.reject(res)
            }
        } else {
            throw new Error(res)
        }
    }
}
function errMsgWhite(url) {
    return url !== '/api/TokenAuth/login' &&
        url !== '/api/TokenAuth/siginBySms'
}

class Http {
    static get(url, param) {
        return ajax({
            url,
            param,
        })
    }

    static post(url, param) {
        return ajax({
            url,
            param,
            type: 'post',
        })
    }

    static del(url, param) {
        return ajax({
            url,
            param,
            type: 'delete',
        })
    }

    static put(url, param) {
        return ajax({
            url,
            param,
            type: 'put',
        })
    }

    static ajax(type = 'get', url, param) {
        return ajax({
            type,
            url,
            param,
        })
    }

    static setOption(key, value) {
        axios.defaults.headers[key] = value
    }
}

export default Http